import { Block, component } from '../../../scripts/core/Component'

@component('page')
class Page extends Block {
  constructor (context) {
    super(context)
  }
  
  enableScroll() {
    let top = -parseInt(this.el.style.top, 10)
    this.modifier('noScroll').off()
    document.body.style.overflow = 'auto'
    document.body.height = 'auto'
  }
  
  disableScroll() {
    this.modifier('noScroll').on()
    document.body.style.overflow = 'hidden'
    document.body.height = '100vh'
  }
  
  _getScroll() {
    return document.documentElement.scrollTop
  }
}

export {
  Page
}


// WEBPACK FOOTER //
// ./components/main/page/index.js